import { Image, Text, View } from 'react-native'
import { useNavigation, useRoute } from '@react-navigation/native'
import type { NativeStackNavigationProp } from '@react-navigation/native-stack'
import type { RouteProp } from '@react-navigation/native'
import { useTranslation } from 'react-i18next'
import { Check } from 'lucide-react-native'
import { Button } from '@chillout/ui'
import { colors } from '@chillout/core'
import { Card } from '../../shared/Card'
import { CashierPublicLayout } from '../shared/CashierPublicLayout'
import { images } from '../../../assets'
import type { CashierStackParamList } from '../../../navigation/types'

type Nav = NativeStackNavigationProp<CashierStackParamList, 'PairingSuccess'>
type Route = RouteProp<CashierStackParamList, 'PairingSuccess'>

export function PairingSuccessScreen() {
  const { t } = useTranslation()
  const navigation = useNavigation<Nav>()
  const { params } = useRoute<Route>()

  return (
    <CashierPublicLayout>
      <View className="flex-1 items-center justify-center px-6 pb-10">
        <Card className="w-full max-w-[480px] items-center px-8 py-10">
          <View className="h-24 w-24 mb-4 items-center justify-center rounded-full bg-success/10">
            <Check size={48} color={colors.success} strokeWidth={2} />
          </View>
          <Text className="mt-6 text-center text-3xl font-bold text-primary">
            {t('cashierPairing.successTitle', {
              deviceName: params.deviceName,
              branchName: params.branchName,
            })}
          </Text>
          <Text className="mt-3 text-center text-base lg:text-lg text-secondary">
            {t('cashierPairing.successSubtitle')}
          </Text>
          <Image
            source={images.pairingSuccess}
            style={{ width: 180, height: 180, marginTop: 32 }}
            resizeMode="contain"
            accessibilityLabel={t('cashierPairing.successImageAccessibilityLabel')}
          />
          <View className="mt-10 w-full">
            <Button
              label={t('cashierPairing.successContinue')}
              onPress={() => navigation.navigate('Home')}
              accessibilityLabel={t('cashierPairing.successContinue')}
            />
          </View>
        </Card>
      </View>
    </CashierPublicLayout>
  )
}
